import React from 'react';

function FormSection({ title, description, bordered = false, children }) {
  return (
    <section
      className={`space-y-4 ${bordered ? 'border-t border-surface-border pt-6' : ''}`}
    >
      <div>
        <h2 className="text-sm font-semibold text-content-primary">{title}</h2>
        {description && (
          <p className="text-xs text-content-muted mt-0.5">{description}</p>
        )}
      </div>
      {children}
    </section>
  );
}

export default FormSection;
